module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Pfaefers-2081bc6006495da95ee57aaa97f29b16.png";